/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodWink2 = createReactComponent("mood-wink-2", "IconMoodWink2", [
  ["path", { d: "M12 21a9 9 0 1 1 0 -18a9 9 0 0 1 0 18z", key: "svg-0" }],
  ["path", { d: "M9 10h-.01", key: "svg-1" }],
  ["path", { d: "M14.5 15a3.5 3.5 0 0 1 -5 0", key: "svg-2" }],
  ["path", { d: "M15.5 8.5l-1.5 1.5l1.5 1.5", key: "svg-3" }]
]);

export { IconMoodWink2 as default };
//# sourceMappingURL=IconMoodWink2.js.map
